import { AccountIdentifier } from '@icp-sdk/canisters/ledger/icp'
import { Principal } from '@icp-sdk/core/principal'
import { useMemo } from 'react'
import { COMMISSIONS_WALLETS, SOL_COMMISSION_WALLET } from '../constants/business'
import { PlugUserActivity } from '../interfaces/transactionActivity'
import { useContacts, useWalletBTCAddresses, useWalletProperties } from '../state'
import { shortAddress } from '../utils/shortAddress'

export const hasOtherParty = (activity: PlugUserActivity) =>
  activity.kind === 'Approve' || activity.kind === 'Transfer'

const commissionWallets = [
  ...COMMISSIONS_WALLETS,
  SOL_COMMISSION_WALLET,
  // commission wallet account IDs
  'b95d0c72133fe13232ba305aaa50020c2d52d0718e6f26ad9eef1e36fa2708ce',
  'd500f8ebedfac1cd11afcbc4845e1cdacb21005fcb4ef88bdc9e46d28b0653bf',
  '6296315d016e1d656fc3795e1272d3c41b32e0784c440ced15532a6fe7e49219',
  '6b3a619166f36a42828653913d2ac3c1d0608a4e0ef7004b41db70e6a9358657',
]

export default ({ activity, long }: { activity: PlugUserActivity; long?: boolean }) => {
  const { getContactsByAddress } = useContacts()
  const { walletNames, walletDogeAddresses, walletSolAddresses, walletEthAddresses } =
    useWalletProperties()
  const { walletBTCAddresses } = useWalletBTCAddresses()

  let address: string
  if (!hasOtherParty(activity)) {
    address = ''
  } else if (activity.isOutgoing) {
    address = activity.to
  } else {
    address = activity.from
  }

  const otherParty = useMemo(() => {
    if (!address) return

    const contacts = getContactsByAddress(address)

    if (contacts.length) {
      return contacts[0].name
    } else if (commissionWallets.includes(address)) {
      return 'Plug Comission'
    } else {
      const aliases = Object.keys(walletNames).map((p) => {
        return [
          p,
          AccountIdentifier.fromPrincipal({ principal: Principal.fromText(p) }).toHex(),
          walletDogeAddresses[p],
          walletSolAddresses[p],
          walletEthAddresses[p],
          walletBTCAddresses[p],
        ].map((a) => a?.toLowerCase())
      })

      const match = aliases.find((addresses) => addresses.includes(address.toLowerCase()))
      if (match) {
        return walletNames[match[0]]
      }
    }
  }, [
    activity,
    getContactsByAddress,
    walletNames,
    walletDogeAddresses,
    walletSolAddresses,
    walletEthAddresses,
    walletBTCAddresses,
  ])

  const leftSize = long ? 12 : undefined

  return {
    otherParty: otherParty || shortAddress(address, { leftSize }),
    isRecognized: !!otherParty,
    isCommissionWallet: commissionWallets.includes(address),
    fullAddress: address,
  }
}
